// extracted by mini-css-extract-plugin
export var typingIndicator = "_mf-0";